import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import {
  ReaImportViewState,
  ReaRecoveryAction,
  ReaTechnicalDetailItem,
} from 'src/app/models/fincas/rea.model';

/**
 * Shows the primary REA import status with user-facing actions first.
 */
@Component({
  selector: 'app-rea-import-main-status',
  templateUrl: './rea-import-main-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReaImportMainStatusComponent {
  @Input({ required: true })
  public viewState!: ReaImportViewState;

  @Input()
  public hasCurrentError = false;

  @Input()
  public recoveryAction: ReaRecoveryAction | null = null;

  @Input()
  public supportEmailHref = '';

  @Input()
  public technicalDetails: ReaTechnicalDetailItem[] = [];

  @Input()
  public primaryValueMessage = '';

  public get statusIcon(): string {
    if (this.hasCurrentError) {
      return 'pi pi-exclamation-triangle';
    }

    return this.viewState.status === 'success' ? 'pi pi-check-circle' : 'pi pi-info-circle';
  }

  public get hasSupportEmail(): boolean {
    return this.supportEmailHref.trim() !== '';
  }

  public get showDescription(): boolean {
    return this.viewState.description.trim() !== ''
      && !(this.viewState.status === 'success' && this.primaryValueMessage.trim() !== '');
  }
}